module.exports = __webpack_public_path__ + "static/24invgde-1c9ae15c5ec9d21c4390c3c9c3b64c5a.gif";